import { z } from 'zod';

export const CommentCreateDataSchema = z.object({
  text: z.string().min(1, { message: 'Required' }),
  entityId: z.string().min(1, { message: 'Required' }),
  entityParentId: z.string().optional(),
});

export type CommentCreateData = z.infer<typeof CommentCreateDataSchema>;
